import React, { useState } from "react"

interface IDocumentCategoryProps {
     title: string
     subtitle?: string
     icon: string // classe font-awesome, ex "fa-file-signature"
     color?: string // couleur metronic, ex "primary"
     children: React.ReactNode
     defaultExpanded?: boolean
     maxHeightPx?: number // hauteur max du contenu avant scroll interne
}

// Conteneur de catégorie de documents : repliable (shrink/expand) + contenu à hauteur
// bornée et défilable, pour empiler plusieurs catégories sans scroller toute la page.
const DocumentCategory = ({ title, subtitle, icon, color = "primary", children, defaultExpanded = true, maxHeightPx = 500 }: IDocumentCategoryProps) => {
     const [expanded, setExpanded] = useState(defaultExpanded)

     return (
          <div className={"card border border-gray-300 shadow-sm"}>
               {/* Header cliquable (replier / déplier) */}
               <div
                    className={"card-header border-gray-200 d-flex align-items-center justify-content-between cursor-pointer"}
                    onClick={() => setExpanded(prev => !prev)}
               >
                    <div className={"d-flex align-items-center py-4"}>
                         <span className={"symbol symbol-45px me-4"}>
                              <span className={`symbol-label bg-light-${color}`}>
                                   <i className={`fas ${icon} fs-2 text-${color}`} />
                              </span>
                         </span>
                         <div className={"d-flex flex-column"}>
                              <h3 className={"fw-boldest text-gray-800 mb-0 fs-4"}>{title}</h3>
                              {subtitle && <span className={"text-muted fs-7"}>{subtitle}</span>}
                         </div>
                    </div>
                    <span className={"btn btn-sm btn-icon btn-active-light-primary"}>
                         <i className={`fas ${expanded ? "fa-chevron-up" : "fa-chevron-down"} fs-4 text-gray-600`} />
                    </span>
               </div>

               {/* Contenu : borné en hauteur et défilable */}
               {expanded && (
                    <div className={"card-body scroll-y"} style={{ maxHeight: maxHeightPx }}>
                         {children}
                    </div>
               )}
          </div>
     )
}

export default DocumentCategory
